import { X_CACHEDQUERY_ID } from '../../../constants';
import { fetcher } from '../../utils/fetchers/fetcher';
import { resolveApiPath } from '../../utils/resolveApiPath';
import { normalizeCachedQueryId } from '../../../utils/dataset/normalizeCachedQueryId';

export const requestDatasetData = (
  api: string,
  token: string | null,
  cachedQueryId?: string | undefined,
  forceHeader?: string
) => {
  const normalizedCachedQueryId = normalizeCachedQueryId(cachedQueryId);
  const headers =
    normalizedCachedQueryId === undefined
      ? undefined
      : {
          [X_CACHEDQUERY_ID]: normalizedCachedQueryId,
        };

  return fetcher<any>(
    resolveApiPath(api),
    'GET',
    token,
    forceHeader,
    undefined,
    undefined,
    headers,
    true,
    undefined,
    true
  );
};
